var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4435 16.2143C18.2294 15.1497 16.9972 14.5048 15.7979 15.5678L15.0818 16.2103C14.5579 16.6767 13.5838 18.8558 9.81737 14.414C6.05177 9.97772 8.29262 9.287 8.81734 8.82464L9.53736 8.18136C10.7303 7.11592 10.2801 5.77467 9.41971 4.39403L8.90048 3.55776C8.03614 2.18033 7.09494 1.27572 5.89882 2.33954L5.25253 2.9185C4.72389 3.31331 3.24619 4.59666 2.88775 7.0347C2.45637 9.96003 3.81719 13.3099 6.93493 16.9855C10.0488 20.6626 13.0975 22.5097 15.9854 22.4775C18.3855 22.451 19.8349 21.1306 20.2883 20.6506L20.9369 20.0708C22.1299 19.0078 21.3887 17.9255 20.1738 16.8584L19.4435 16.2143Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d88dd02b470a13770fbd909f7d56dce1.svg";
export { ForwardRef as ReactComponent };